import { parse } from 'date-fns';
import { getConfig } from './utils.js';

// preflight reason strings matched in runPreflight
export const ANONYMOUS = 'anonymous';
export const NO_LANG_TOKENS = 'no_lang_tokens';
export const AUDIO_ONLY = 'audio_only';
export const NO_SUBSCRIPTION = 'no_subscription';
export const CONDITIONS_PENDING = 'conditions_pending';

/* eslint-disable max-len */

export const NO_SUBSCRIPTION_MSG = 'You need an active subscription to use this AI feature. Would you like to learn more about our subscriptions?';
export const AUDIO_ONLY_MSG = 'Full Access is required to explore this AI feature. Would you like to upgrade your subscription?';
export const CONVERSATION_EXPIRED_MSG = 'This Deep Dive has expired and history is no longer available.';
export const GENERIC_ERROR_MSG = 'Oops! An error occurred. Please contact the site administrator.';
export const STREAM_ERROR = 'Oops! We ran into a problem when generating this response. Reloading your Deep Dive now.';
export const MAINTENANCE_ERROR = 'AI is temporarily unavailable due to maintenance.';
export const UNAUTHORIZED_MSG = 'You are not authorized to use this AI feature. Please refresh the page and try again.';
export const OFFLINE_MSG = "We couldn't reach the server. Please check your connection and try again.";

export const getNoTokensMessage = () => {
    return `You're all out of tokens.<br/>You can purchase additional tokens now or wait until your monthly allowance renews${getRebillDateTxt()}. Would you like to buy more tokens?`;
};

export const getLowBalanceMessage = () => {
    return `Your balance is low.<br/>This AI feature uses tokens. Your token allowance will renew with your subscription${getRebillDateTxt()}. But you can purchase additional tokens if your allowance runs out. Would you like to buy more tokens?`;
};

function getRebillDateTxt() {
    const rebillDateRaw = getConfig('rebillDate');
    const rebillDate = rebillDateRaw
        ? parse(rebillDateRaw, 'yyyy-MM-dd', new Date())
        : null;
    return  rebillDate
        ? ` on: ${rebillDate.toLocaleDateString('en-US', { dateStyle: 'full' })}`
        : '';
}

/* eslint-enable max-len */
